import React from 'react';
import { observer } from 'mobx-react';
import { SpinnerIcon } from '@estee/elc-icons';
import { ITranslationsCollection, translate } from '@estee/elc-service';

import {
    Container,
    Label,
    PriceWrapper,
    EngravingEdit,
    EngravingEditIcon,
    EngravingDisclaimer
} from '~views/ShoppingBagTab/CartSidebarItems/CartItem/EngravingComponent/EngravingComponentStyles';

import { classes } from '~utils/ClassNames';
import PriceItem from '~views/ShoppingBagTab/CartSidebarItems/CartItem/CartItemPriceWrapper/PriceItem/PriceItem';
import { IEngravingKitItem } from '~views/ShoppingBagTab/CartSidebarItems/CartItem/EngravingComponent/IEngravingComponent';
import Tooltip from '~views/Shared/Tooltip/Tooltip';
import { useEngraving } from './EngravingHook';
import { StyledButton } from '~views/Collection/CollectionStyles';

const engraveName = 'cart-item-engrave';
export const engraveClass = classes(engraveName);
export const messageClass = classes(`${engraveName}-message`);
export const priceClass = classes(`${engraveName}-price`);
export const disclaimerClass = classes(`${engraveName}-disclaimer`);
export const engravingLabelClass = classes(`${engraveName}-label`);
export const engravingPositionClass = classes(`${engraveName}-position`);
export const engravingRemoveClass = classes(`${engraveName}-remove`);
export const engravingEditClass = classes(`${engraveName}-edit`);
export const engravingTooltipClass = classes(`${engraveName}-tooltip`);
export const engravingTooltipIconClass = classes(`${engraveName}-tooltip-icon`);

export const EngravingComponent = translate([
    'engravingLabel',
    'engravingInfo',
    'engravingNote',
    'engravingDisclaimer',
    'removeLabel'
])(
    observer(({ engraving, kitInfo, translations }: IEngravingKitItem) => {
        const { message, priceDetails, selectedFontClassName, removeItem, isLoading } =
            useEngraving({
                engraving,
                kitInfo
            });

        const { engravingLabel, engravingInfo, engravingNote, engravingDisclaimer, removeLabel } =
            translations as ITranslationsCollection;

        return (
            <Container className={engraveClass} data-testid={engraveClass}>
                <PriceWrapper className={priceClass} data-testid={priceClass}>
                    <Label className={engravingLabelClass}>{engravingLabel}</Label>
                    <Label className={engravingPositionClass}>{engraving.engravingType}</Label>
                    <div className={messageClass} data-testid={messageClass}>
                        {message.map((messageLine, i) => (
                            <p key={i} className={selectedFontClassName}>
                                {`${messageLine}`}
                            </p>
                        ))}
                    </div>
                    <PriceItem {...priceDetails} showDiscountedTotal={true} />
                </PriceWrapper>
                {isLoading ? (
                    <SpinnerIcon />
                ) : (
                    <>
                        <StyledButton
                            className={engravingRemoveClass}
                            data-testid={engravingRemoveClass}
                            onClick={removeItem}
                        >
                            {removeLabel}
                        </StyledButton>
                        <EngravingEdit
                            className={engravingEditClass}
                            data-testid={engravingEditClass}
                        >
                            {engravingInfo}
                        </EngravingEdit>
                        <Tooltip hiddenText={engravingNote} placement="bottom">
                            <EngravingEditIcon className={engravingTooltipIconClass} />
                        </Tooltip>
                    </>
                )}
                <EngravingDisclaimer className={disclaimerClass} data-testid={disclaimerClass}>
                    {engravingDisclaimer}
                </EngravingDisclaimer>
            </Container>
        );
    })
);
